// Shared route header — sets the kicker label, title, and
// optional right-side actions for any route.

import type { ReactNode } from 'react'
import { Breadcrumbs } from '@square/ui'

export interface RouteHeaderProps {
  kicker: string
  title: string
  description?: string
  crumbs?: Array<{ label: string; href?: string; onClick?: () => void }>
  actions?: ReactNode
}

export default function RouteHeader({
  kicker,
  title,
  description,
  crumbs,
  actions,
}: RouteHeaderProps) {
  return (
    <div style={{ marginBottom: 24 }}>
      {crumbs && crumbs.length > 0 && <div style={{ marginBottom: 8 }}><Breadcrumbs items={crumbs} /></div>}
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 16 }}>
        <div>
          <div
            style={{
              fontSize: 9,
              color: 'var(--olv-text-tertiary)',
              fontFamily: 'var(--font-mono)',
              letterSpacing: '0.14em',
              marginBottom: 6,
            }}
          >
            {kicker}
          </div>
          <h1
            style={{
              fontFamily: 'var(--font-brand)',
              fontWeight: 600,
              fontSize: 24,
              margin: 0,
              color: 'var(--olv-text-primary)',
            }}
          >
            {title}
          </h1>
          {description && (
            <div style={{ fontSize: 12, color: 'var(--olv-text-secondary)', marginTop: 4 }}>
              {description}
            </div>
          )}
        </div>
        {actions && <div style={{ display: 'flex', gap: 8 }}>{actions}</div>}
      </div>
    </div>
  )
}
